import React from 'react'

import { Grid, Header, Button, Card, Image, Divider } from 'semantic-ui-react'

import LaurenHudsonAvatar from '../../../_images/lauren-hudson-avatar.jpg'
import { HELPDOCS_URL } from '../../../config/environments'

import ExternalLink from '../../../components/common/ExternalLink'

const CollaborateTab = () => {
  const goToBookingCalendar = () => {
    window.open('https://vloggi.com/book-a-demo', '_blank')
  }

  return (
    <Grid stackable>
      <Grid.Column width={8}>
        <Header as="h2" style={{ fontWeight: 'bold' }}>
          Book a demo
        </Header>

        <Card fluid>
          <Card.Content>
            <Image floated="left" size="tiny" src={LaurenHudsonAvatar} style={{ borderRadius: '50%' }} />
            <Card.Header>Lauren Hudson</Card.Header>
            <Card.Meta>Customer Success Manager</Card.Meta>
            <Card.Description>
              Book a <strong>15 mins Onboarding session</strong> with me to learn more about the Vloggi platform and to
              maximize the value of your campaigns.
            </Card.Description>
          </Card.Content>
          <Card.Content extra>
            <div className="ui two buttons">
              <Button primary onClick={goToBookingCalendar}>
                Book Now
              </Button>
            </div>
          </Card.Content>
        </Card>
      </Grid.Column>

      <Grid.Column width={8}>
        <Header as="h2" style={{ fontWeight: 'bold' }}>
          Help center
        </Header>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <Button fluid basic color="orange" size="large" as="a" href="https://vloggi.com/docs/vloggi-quick-start-guide/" target="_blank">
            Vloggi Quick Start Guide
          </Button>

          <Button fluid basic color="orange" size="large" as="a" href="https://vloggi.com/docs/how-to-collect-curate-and-combine-user-generated-videos-at-scale-with-vloggi-an-overview/" target="_blank">
            How to use Vloggi: An overview
          </Button>
        </div>
        
        <Divider />

        <div style={{ textAlign: 'center' }}>
          <ExternalLink url={HELPDOCS_URL}>Read more</ExternalLink>
        </div>
      </Grid.Column>
    </Grid>
  )
}

export default CollaborateTab
